module.exports = __webpack_public_path__ + "static/media/compliance_subbanner2.761f11f5.webp";